import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCalendarXmark, faCalendar, faListCheck, faCashRegister, faMoneyCheckAlt, 
    faPiggyBank, faCarrot, faBookOpen, faCalendarAlt, faSeedling, faAsterisk, faGifts, 
    faUtensils, faCloudMoon, faSuitcase, faCar, faTrash, faFolder, faUserCheck, 
    faSyringe, faHandHoldingHeart, faHeart, faClipboardList, faFileArchive, faFamily, 
    faUsers, faHeart as faHeartSolid,
    faCameraRetro,
    faFaceSmile,
    faFaceGrinHearts,
    faDog,
    faCat,
    faHorse,
    faCow,
    faDove,
    faCalendarCheck,
    faFeatherAlt,
    faPenFancy,
    faGaugeHigh,
    faPersonBurst,
    faMobile,
    faKitMedical,
    faShoppingBasket
} from '@fortawesome/free-solid-svg-icons';
import './LifeChroniclesHome.css';
import lifechroniclesimage from '../../assets/pageimages/LifeChronicle.webp';

const categories = [
    { to: "/chronicle-calendar", icon: faCalendarXmark, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/chronicle-planner", icon: faCalendar, label: "Planner", bgColor: "bg-teal-500", textColor: "text-white" },
    { to: "/chronicle-todo", icon: faListCheck, label: "Checklist", bgColor: "bg-purple-500", textColor: "text-white" },
    { to: "/myroutines-diet", icon: faCarrot, label: "Diet Routine", bgColor: "bg-orange-500", textColor: "text-white" },
    { to: "/myroutines-others", icon: faCalendarAlt, label: "Other Routines", bgColor: "bg-pink-500", textColor: "text-white" },
    { to: "/tasks-list", icon: faAsterisk, label: "Tasks", bgColor: "bg-gray-700", textColor: "text-white" },
    { to: "/gift-list", icon: faGifts, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
    { to: "/checklist", icon: faUtensils, label: "Checklist", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/events-list", icon: faCalendar, label: "Events", bgColor: "bg-purple-600", textColor: "text-white" },
    { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-pink-600", textColor: "text-white" },
    { to: "/feelings-list", icon: faHeartSolid, label: "Feelings", bgColor: "bg-pink-600", textColor: "text-white" },
    { to: "/food-list", icon: faUtensils, label: "Food", bgColor: "bg-yellow-700", textColor: "text-white" },
    { to: "/goals-list", icon: faCalendar, label: "Goals", bgColor: "bg-teal-700", textColor: "text-white" },
    { to: "/gratitudes-list", icon: faHeartSolid, label: "Gratitude", bgColor: "bg-orange-700", textColor: "text-white" },
    { to: "/invitations-list", icon: faHandHoldingHeart, label: "Invitation", bgColor: "bg-purple-700", textColor: "text-white" },
    { to: "/illness-list", icon: faKitMedical, label: "Illness", bgColor: "bg-teal-800", textColor: "text-white" },
    { to: "/medicine-list", icon: faSyringe, label: "Medicine", bgColor: "bg-teal-800", textColor: "text-white" },
    { to: "/memories-list", icon: faCameraRetro, label: "Memories", bgColor: "bg-purple-900", textColor: "text-white" },
    { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly Essentials Plan", bgColor: "bg-yellow-700", textColor: "text-white" },
    { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-yellow-400", textColor: "text-red" },
    { to: "/play-list", icon: faHeartSolid, label: "Play/Entertainment", bgColor: "bg-purple-800", textColor: "text-white" },
    { to: "/physical-growth-list", icon: faGaugeHigh, label: "Physical Growth", bgColor: "bg-green-800", textColor: "text-white" },
    { to: "/unspecified-list", icon: faFolder, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
    { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
];

const LifeChroniclesKidsHome = () => {
    const navigate = useNavigate();

    const [myHealthCardClicked, setMyHealthCardClicked] = useState(false);
    const [chronicleClicked, setChronicleClicked] = useState(false);
    const [petDashboardClicked, setPetDashboardClicked] = useState(false);

    const handleChronicleClicked = () => {
        setChronicleClicked(!chronicleClicked);
    }
    
    const handleMyHealthCardClicked = () => {
        setMyHealthCardClicked(true);
    }

    const handlePetDashboardClicked = () => {
        setPetDashboardClicked(true);
    }

    const handleMyDiariesClicked = () => {
        navigate("/mydiary/2");
    }

    return (
        <MainLayout>
            <div className='flex flex-col'>
                <div className="flex flex-col items-center p-4 bg-gray-700 h-auto mt-12">
                    <p className="text-2xl font-extrabold mb-2 text-white">Kids Chronicles</p>
                    <img 
                        src={lifechroniclesimage} 
                        alt="Life Chronicles" 
                        className="w-full h-64 object-cover mb-6 rounded-lg shadow-lg" 
                    />

                    <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                        <button  
                            onClick={handleChronicleClicked} 
                            className="w-full sm:w-auto px-6 py-4 rounded-lg bg-blue-700 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faCalendarCheck} className="text-red-600 mr-2"/>
                            <span className="text-m font-semibold text-yellow-300">Kids Chronicles</span>
                        </button>
                        { chronicleClicked && (
                            <div className="flex flex-col items-center p-4 bg-gray-800">
                                <h1 className="text-xl font-extrabold mb-2 text-gray-800">Kids Life Chronicles</h1>
                                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                                    {categories.map((category, index) => (
                                        <Link 
                                            key={index} 
                                            to={category.to} 
                                            className={`flex flex-col items-center p-6 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                                        >
                                            <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                            <span className="text-m font-semibold flex items-center justify-center text-center">{category.label}</span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                        
                        <button  
                            onClick={handleMyDiariesClicked} 
                            className="w-full sm:w-auto px-6 py-4 rounded-lg bg-blue-700 text-white shadow-lg hover:shadow-2xl transition-shadow duration-300 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faPenFancy} className="text-red-600 mr-2"/>
                            <span className="text-m font-semibold text-yellow-300">Kids Diaries</span>
                        </button>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default LifeChroniclesKidsHome;
